import React from "react";

import ExerciseLibraryCoachComponent from "../../dashboard/settings/ExerciseLibraryCoachComponent";
import AdminToggle from "../components/AdminToggle";

const ExerciseLibrary = (props, { locals }) => {
  const {
    activeUser,
    query: { primary, type },
    exerciseCatalog,
  } = locals;

  return (
    <main className="admin">
      <AdminToggle />

      <ExerciseLibraryCoachComponent
        type={type}
        primary={primary}
        secondaries={exerciseCatalog}
        activeUser={activeUser}
        isAdminConsole
      />
    </main>
  );
};

export default ExerciseLibrary;
